exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert-row {\r\n    padding-top: 40px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/app/components/settings-client/settings-client.component.css
// module id = ../../../../../src/app/components/settings-client/settings-client.component.css
// module chunks = main